export const userManagementNewUserT = {
  createUserDialog: {
    title: 'Add New User',

    fields: {
      firstName: 'First Name',
      lastName: 'Last Name',
      email: 'E-mail',
      role: 'Role'
    },

    placeholders: {
      firstName: 'Enter first name',
      lastName: 'Enter last name',
      email: 'Enter email address',
      role: 'Select a role'
    },

    messages: {
      firstNameRequired: 'Please enter first name',
      lastNameRequired: 'Please enter last name',
      emailRequired: 'Please enter email',
      emailInvalid: 'Please enter valid email',
      roleRequired: 'Please select a role',

      roleInfo:
        'Includes permission to approve batch and manual payouts subject to approval workflows.'
    },

    actions: {
      cancel: 'Cancel',
      submit: 'Add User'
    },

    feedback: {
      successTitle: 'User added',
      successBody: 'The user has been successfully added.',

      deactivatedTitle: 'Deactivated account detected',
      deactivatedBody:
        "The user you're trying to add already exists and is currently deactivated.",
      contactSupportPrefix: 'To restore access, please contact',

      reviewFormTitle: 'Please review the form',
      reviewFormBody:
        'Some fields need your attention. Please fix the highlighted fields and try again.',

      genericErrorTitle: 'Unable to create user',
      genericErrorBodyPrefix: 'If the issue persists, please contact support at'
    }
  }
} as const;
